<template>
  <div class="statement-react">
    <remove-button @toggleOn="removeConvoStatement()" />
  </div>
</template>

<script>
  import StatementConvoRemove from "./StatementConvoRemove.ts";

  export default StatementConvoRemove;
</script>
